import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgChartsModule } from 'ng2-charts';
import { ColorPickerModule } from 'ngx-color-picker';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BarChartComponent } from '../componentes/chart/bar-chart/bar-chart.component';
import { ComboSearchComponent } from '../componentes/combo-search/combo-search.component';
import { DadosCotacaoComponent } from '../componentes/endosso/dados-cotacao/dados-cotacao.component';
import { FiltroComponent } from '../componentes/filtro/filtro.component';
import { MinhaAtividadeComponent } from '../componentes/minha-atividade/minha-atividade.component';
import { PdfViewerComponent } from '../componentes/pdf-viewer/pdf-viewer.component';
import { TopPrioridadesComponent } from '../componentes/top-prioridades/top-prioridades.component';
import { CpfCnpjMaskDirective } from '../diretivas/cpfCnpjMaskDirective';
import { MarkBoldPipe } from '../pipes/markBold/markBold.pipe';
import { AvisoComponent } from './../componentes/aviso/aviso.component';
import { BtnCrudComponent } from './../componentes/btn-crud/btn-crud.component';
import { DragDropComponent } from './../componentes/drag-drop/drag-drop.component';
import { InformacoesAdicionaisComponent } from './../componentes/informacoes-adicionais/informacoes-adicionais.component';
import { MonitorComponent } from './../componentes/monitor/monitor.component';
import { PaginatorComponent } from './../componentes/paginator/paginator/paginator.component';
import { PesquisaComponent } from './../componentes/pesquisa/pesquisa.component';
import { SpinnerComponent } from './../componentes/spinner/spinner.component';
import { TituloComponent } from './../componentes/titulo/titulo.component';
import { CpfPipe } from './../pipes/cpf/cpf.pipe';
import { RealPipe } from './../pipes/real/real.pipe';
import { SafePipe } from './../pipes/safe/safe.pipe';
import { BtnInfoComponent } from './buttom/btn-info/btn-info.component';
import { SharedPaginatorIntl } from './sharedPaginatorIntl';

const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [
    PaginatorComponent,
    FiltroComponent,
    TituloComponent,
    BtnCrudComponent,
    RealPipe,
    MarkBoldPipe,
    CpfPipe,
    SafePipe,
    SpinnerComponent,
    PesquisaComponent,
    BarChartComponent,
    DragDropComponent,
    MonitorComponent,
    PdfViewerComponent,
    TopPrioridadesComponent,
    InformacoesAdicionaisComponent,
    BtnInfoComponent,
    DadosCotacaoComponent,
    MinhaAtividadeComponent,
    AvisoComponent,
    ComboSearchComponent,
    CpfCnpjMaskDirective,
  ],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatGridListModule,
    MatDividerModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatDatepickerModule,
    DragDropModule,
    MatTabsModule,
    MatExpansionModule,
    ColorPickerModule,
    AngularEditorModule,
    MatDialogModule,
    MatRadioModule,
    NgChartsModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PaginatorComponent,
    FiltroComponent,
    TituloComponent,
    BtnCrudComponent,
    SpinnerComponent,
    PesquisaComponent,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatGridListModule,
    MatDividerModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    RealPipe,
    MarkBoldPipe,
    CpfPipe,
    SafePipe,
    NgxMaskDirective,   
    NgxMaskPipe,
    NgxMatSelectSearchModule,
    DragDropModule,
    BarChartComponent,
    DragDropComponent,
    MatTabsModule,
    MatExpansionModule,
    MonitorComponent,
    PdfViewerComponent,
    TopPrioridadesComponent,
    InformacoesAdicionaisComponent,
    BtnInfoComponent,
    DadosCotacaoComponent,
    ColorPickerModule,
    MinhaAtividadeComponent,
    AngularEditorModule,
    AvisoComponent,
    MatRadioModule,
    NgChartsModule,
    ComboSearchComponent,
    CpfCnpjMaskDirective,
  ],
  providers: [
    provideNgxMask(maskConfig),
    { provide: MatPaginatorIntl, useClass: SharedPaginatorIntl },
    RealPipe, // No longer need to provide as a class, just the pipe itself
    MarkBoldPipe, // No longer need to provide as a class, just the pipe itself
  ]
})
export class SharedModule { }
